import type { AxiosRequestConfig } from 'axios';
import { AGraphEnvType, CHANNEL_HEADER, STRIPE_HEADER } from '../../APIConstants';
import { awPortfolioAnalysisReportApiClient } from './Base';
import type {
  GenerateConstraintsRequest,
  GenerateConstraintsResponse,
  GenerateRelevantColumnsRequest,
  GenerateRelevantColumnsResponse,
} from './types';

/*
 * The /api/wealth/analytics/reporting/v1/smartFilters endpoint does not yet have a beta instance deployed.
 * Until it does:
 * - CHANNEL_HEADER is hardcoded to stable so non-prod environments still hit a working instance.
 * - STRIPE_HEADER is explicitly set to undefined to prevent the Base interceptor from injecting
 *   a non-prod stripe value that would target a non-existent instance.
 */
const SMART_FILTER_API_CONFIG = {
  headers: {
    [CHANNEL_HEADER]: AGraphEnvType.STABLE,
    [STRIPE_HEADER]: undefined,
  },
};

/**
 * Restricted config type for SmartFilters API calls.
 * Only allows signal for request cancellation to prevent unintended Axios config exposure.
 */
type SmartFiltersRequestConfig = Pick<AxiosRequestConfig, 'signal'>;

export function generateRelevantColumns(body: GenerateRelevantColumnsRequest, config?: SmartFiltersRequestConfig) {
  return awPortfolioAnalysisReportApiClient.post<GenerateRelevantColumnsResponse>(
    'smartFilters:generateRelevantColumns',
    body,
    { ...SMART_FILTER_API_CONFIG, ...config }
  );
}

export function generateConstraints(body: GenerateConstraintsRequest, config?: SmartFiltersRequestConfig) {
  return awPortfolioAnalysisReportApiClient.post<GenerateConstraintsResponse>(
    'smartFilters:generateConstraints',
    body,
    { ...SMART_FILTER_API_CONFIG, ...config }
  );
}
